import React from 'react'
import './Loading.scss'
import logo from '../../assets/images/logo.jpeg'

export default function Loading() {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <img src={logo} className="image" alt="" />
      </div>
    </div>
  )
}
